export default __webpack_public_path__ + "static/media/eudelegation_light.c29477db.png";